// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cREy","placeholdersHeader":"styles_placeholdersHeader__3zvIE","editorStyle":"styles_editorStyle__2TgBg","placeholdersBox":"styles_placeholdersBox__25W8d"};